import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import IntroSplash from "./IntroSplash";
import MockupGateway from "./MockupGateway";
import VariantSwitcher from "./VariantSwitcher";

// Flow controller: intro animation -> gateway choice -> site content.
const MockupShell = ({ theme, children }) => {
  const [phase, setPhase] = useState("intro"); // intro | gateway | site

  return (
    <>
      <AnimatePresence mode="wait">
        {phase === "intro" && (
          <IntroSplash key="intro" theme={theme} onDone={() => setPhase("gateway")} />
        )}
        {phase === "gateway" && (
          <MockupGateway key="gateway" theme={theme} onEnter={() => setPhase("site")} />
        )}
      </AnimatePresence>

      {phase === "site" && children}

      <VariantSwitcher />
    </>
  );
};

export default MockupShell;
